<template>
  <div class="view_box" :class="isAni ? 'ani':''">
    <div class="title">11.11活动效果回顾</div>
    <div>今年11.11，有<span class="font_color">&nbsp;{{ data.newCustomerNum1111 }}&nbsp;</span>人新加入店铺会员</div>
    <div>有<span class="font_color">&nbsp;{{ data.newPayCustomerNum1111 }}&nbsp;</span>个新会员，完成下单转化</div>
    <div style="margin-top: 30px;">把握方向，猜准节奏</div>
    <div>通过巧妙运营助推店铺会员飞速增长！</div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    isAni:{
      type:Boolean,
      default:true,
    },
    data: {
      type: Object,
      default: ()=> {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@keyframes view_box_s {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ani{
  animation: view_box_s 1.5s ease-in;
  animation-fill-mode: both;
  border-radius: 16px;
}
.view_box {
  position: relative;
  width: 100%;
  height: 100%;

  padding: 50px;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
  font-family: PingFang SC;
  background-image: url("../../assets/images/yearReport/P7.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  div {
    font-family: PingFang SC;
    width: 100%;
    margin-bottom: 12px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 28px;
    margin-bottom: 30px;
  }

  .font_color {
    color: #0b79ff;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }
}
</style>
